const instagramIcon = (): JSX.Element => {
 return <img src="images/Group 1.png" alt="instagram" />;
};

export default instagramIcon;
